<template>
  <div class="d-flex align-center test" style="gap:12px;">
    <v-tooltip top>
      <template #activator="{ on }">
          <div v-on="on" class="led mr-4" :class="[statusColor.background]" @click="$emit('led-pressed')"/>
      </template>
      {{ status }}
    </v-tooltip>
    <smart-btn v-show="ping" @click.native="sendPing" small secondary> Ping </smart-btn>
    <smart-btn v-show="pong" @click.native="sendPong" small secondary> Pong </smart-btn>
    <slot />
  </div>
</template>


<script>
import {WS_STATUS} from "@/services/createWebSocketService";

export default {
  name: "WidgetWebSocketControlPanel",
  props: {
    ping: { type: Boolean, default: false },
    pong: { type: Boolean, default: false  },
  },
  inject: ["webSocketService"],
  emits: ['led-pressed', 'ping', 'pong'],
  computed: {
    status() {
      return this.webSocketService.state.status
    },
    statusColor() {
      if (this.status === WS_STATUS.CONNECTED) {
        return { background: "green lighten-1" }
      }
      if (this.status === WS_STATUS.CONNECTING) {
        return { background: "yellow lighten-1" }
      }
      if (this.status === WS_STATUS.ERROR) {
        return { background: "red lighten-1" }
      }
      if (this.status === WS_STATUS.NOT_CONNECTED) {
        return { background: "grey lighten-1"}
      }
      return { background: "grey lighten-4" }
    },
  },
  methods: {
    sendPing() { this.webSocketService.sendPing() },
    sendPong() { this.webSocketService.sendPong() },
  }
}
</script>


<style scoped>
.led {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  cursor: pointer;
}
</style>